// extracted by mini-css-extract-plugin
export default {"editButton":"addDeduction_editButton__hywco","TableBody":"addDeduction_TableBody__f82yo","deleteButton":"addDeduction_deleteButton__whnut"};